module.exports = __webpack_public_path__ + "static/media/gcdef_105.ec18672d.ico";